import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import FieldErrorMessage from '../FieldErrorMessage';
import Hint from "../Hint";

const Input = ( props ) => {
    // eslint-disable-next-line react/prop-types
    const { label, name, type, defaultValue, isRequired, rules, hint } = props;
    const { register, unregister } = useFormContext();

    useEffect( () => {
        return () => {
            unregister( name )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <div className={`form-item form-item--input`}>
            <label htmlFor={name}>
                {label}
                {isRequired && <span className="required">*</span>}
                {hint && <Hint hint={hint}/>}
            </label>
            <input
                id={name}
                type={type}
                name={name}
                required={isRequired}
                ref={register( rules )}
                defaultValue={defaultValue}
            />
            <FieldErrorMessage name={name}/>
        </div>
    );
};

Input.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    isRequired: PropTypes.bool,
    rules: PropTypes.objectOf( PropTypes.any ),
};

Input.defaultProps = {
    type: 'text',
    isRequired: true,
    rules: null,
    defaultValue: null,
};

export default Input;
